import { SsoProviderService, type CheckDomainBodyDto } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { TCall } from 'app/queries/types/TCall';

type TParams = {
  call: TCall;
  requestBody: CheckDomainBodyDto;
  signal: AbortSignal;
};

export const checkDomain = ({ call, requestBody, signal }: TParams) =>
  call(() => cancelOnSignal(SsoProviderService.checkDomain({ requestBody }), signal), {
    dontRedirectOnError: true,
    onError: () => undefined,
  });
